import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { QarepaBaseFormsDirective } from '@qarepa/common';

export class AccountEditForm extends QarepaBaseFormsDirective {
  private skeleton = {
    id: [0, Validators.required],
    identifier: ['Roger Cali', [Validators.required, Validators.minLength(4)]],
    name: ['', [Validators.required, Validators.minLength(4)]],
    image: new FormControl<string | null>(null),
  };

  protected form = this.fb.nonNullable.group(this.skeleton);

  get id() {
    return this.form.get('id') as AbstractControl;
  }

  get identifier() {
    return this.form.get('identifier') as AbstractControl;
  }

  get name() {
    return this.form.get('name') as AbstractControl;
  }

  get image() {
    return this.form.get('image') as AbstractControl;
  }

  get dirtyValidForm() {
    return this.form.dirty && this.form.valid;
  }

  get validatedForm() {
    return this.dirtyValidForm && !this.submitting;
  }
}
